import AxiosInstance from "./api";

export const ValueAddedTaxFilingService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/value-added-tax-filing/paginate", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/value-added-tax-filing/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/value-added-tax-filing/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/value-added-tax-filing", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/value-added-tax-filing/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/value-added-tax-filing/" + id);
  },
};
